import { apiHelper } from '../utils/apiHelper';

const API_URL = `${process.env.REACT_APP_API_URL}/api/admin/city`;

const headers = {
  "Content-Type": "multipart/form-data",
  "Accept": "application/json"
};

export const fetchCities = (payload) => apiHelper(API_URL, 'GET', payload);
export const createCity = (payload) => apiHelper(API_URL, 'POST', payload, headers);
export const fetchCity = (cityId) => apiHelper(`${API_URL}/${cityId}`, 'GET');
export const modifyCity = (payload) => apiHelper(`${API_URL}/${payload.get('id')}`, 'POST', payload, headers);
export const deleteCityApi = (cityId) => apiHelper(`${API_URL}/${cityId}`, 'DELETE');
export const changeStatus = (cityId) => apiHelper(`${API_URL}/change-status/${cityId}`, 'POST');

